/**
 * Správní řízení > Běžící lhůty
 */
(function ($) {
	// this script does not have to run on other pages
	if ($('#procedure-group-deadlines').length === 0) {
		return;
	}

	let body = $('body');

	// Show / hide popup
	body.on('click', '.procedure-group-deadlines-popup-toggle', function (event) {
		let procedureGroupDeadlinePopup = $('#procedure-group-deadlines-popup');
		if (procedureGroupDeadlinePopup.css('display') === 'none') {
			procedureGroupDeadlinePopup.show();
			procedureGroupDeadlinePopup.css('right', 'auto');
			procedureGroupDeadlinePopup.css('left', event.pageX + 'px');
			procedureGroupDeadlinePopup.css('top', event.pageY + 'px');
			procedureGroupDeadlinePopup.removeClass('right');

			if (event.pageX + 250 > body.width()) {
				procedureGroupDeadlinePopup.css('left', 'auto');
				procedureGroupDeadlinePopup.css('right', body.width() - event.pageX + 'px');
				procedureGroupDeadlinePopup.addClass('right');
			}
		} else {
			procedureGroupDeadlinePopup.hide();
		}
	});

	// Hide popup when user clicks outside
	$(document).click(function (event) {
		if (
			!$(event.target).hasClass('procedure-group-deadlines-popup-toggle') &&
			$(event.target).parents('#procedure-group-deadlines-popup').length === 0
		) {
			$('#procedure-group-deadlines-popup').hide();
			event.stopPropagation();
		}
	});

	// Update deadlines on checkbox change
	body.on('change', '#procedure-group-deadlines-popup input', function () {
		updateDeadlines(true);
	});

	// Zaškrnout vše
	body.on('click', '#procedure-group-deadlines-check-all', function () {
		$('#procedure-group-deadlines-popup input').prop('checked', true);
		updateDeadlines(true);
	});

	// Odškrtnout vše
	body.on('click', '#procedure-group-deadlines-uncheck-all', function () {
		$('#procedure-group-deadlines-popup input').prop('checked', false);
		updateDeadlines(true);
	});

	let getCheckedProcedureGroupIds = function () {
		let checkedProcedureGroupIds = [];

		$('#procedure-group-deadlines-popup input:checked').each(function () {
			checkedProcedureGroupIds.push($(this).val());
		});

		return checkedProcedureGroupIds;
	};

	let getUncheckedProcedureGroupIds = function () {
		let uncheckedProcedureGroupIds = [];

		$('#procedure-group-deadlines-popup input:not(:checked)').each(function () {
			uncheckedProcedureGroupIds.push($(this).val());
		});

		return uncheckedProcedureGroupIds;
	};

	let updateTable = function (checkedProcedureGroupIds) {
		let hideTable = true;

		// Hide / show <tr>
		$('#procedure-group-deadlines-list-table tbody tr').each(function () {
			let tr = $(this);
			let hideTr = true;

			tr.find('.procedure-group').each(function () {
				let procedureGroupId = $(this).data('procedureGroupId');

				if (checkedProcedureGroupIds.includes(procedureGroupId)) {
					hideTr = false;
					hideTable = false;
				}
			});

			if (hideTr) {
				tr.hide();
			} else {
				tr.show();
			}
		});

		// Hide / show <table>
		if (hideTable) {
			$('#procedure-group-deadlines-list-table').hide();
			$('#procedure-group-deadlines-message').show();
		} else {
			$('#procedure-group-deadlines-list-table').show();
			$('#procedure-group-deadlines-message').hide();
		}
	};

	let updateHeader = function (checkedProcedureGroupIds, uncheckedProcedureGroupIds) {
		$('.selected-procedure-group').each(function () {
			$(this).removeClass('checked');
			let procedureGroupId = $(this).data('procedureGroupId');

			if (checkedProcedureGroupIds.includes(procedureGroupId)) {
				$(this).addClass('checked');
			}
		});

		// show "(+ X dalších)"
		if (checkedProcedureGroupIds.length === 0 && uncheckedProcedureGroupIds.length === 0) {
			$('#procedure-group-deadlines-filtered-empty').show();
			$('#procedure-group-deadlines-filtered-all').hide();
			$('#procedure-group-deadlines-and-other').hide();
			$('#procedure-group-deadlines-filtered-groups-heading .groups').hide();
			return;
		}

		if (checkedProcedureGroupIds.length === 0 && uncheckedProcedureGroupIds.length > 0) {
			$('#procedure-group-deadlines-filtered-empty').show();
			$('#procedure-group-deadlines-filtered-all').hide();
			$('#procedure-group-deadlines-and-other').hide();
			$('#procedure-group-deadlines-filtered-groups-heading .groups').hide();
			return;
		}

		if (checkedProcedureGroupIds.length > 0 && uncheckedProcedureGroupIds.length === 0) {
			$('#procedure-group-deadlines-filtered-empty').hide();
			$('#procedure-group-deadlines-filtered-all').show();
			$('#procedure-group-deadlines-and-other').hide();
			$('#procedure-group-deadlines-filtered-groups-heading .groups').hide();
			return;
		}

		if (checkedProcedureGroupIds.length === 1) {
			$('#procedure-group-deadlines-filtered-empty').hide();
			$('#procedure-group-deadlines-filtered-all').hide();
			$('#procedure-group-deadlines-and-other').hide();
			$('#procedure-group-deadlines-filtered-groups-heading .groups').show();
			return;
		}

		if (checkedProcedureGroupIds.length > 1 && checkedProcedureGroupIds.length <= 5) {
			$('#procedure-group-deadlines-filtered-empty').hide();
			$('#procedure-group-deadlines-filtered-all').hide();
			$('#procedure-group-deadlines-and-other')
				.show()
				.text('+ ' + (checkedProcedureGroupIds.length - 1) + ' další');
			$('#procedure-group-deadlines-filtered-groups-heading .groups').show();
			return;
		}

		$('#procedure-group-deadlines-filtered-empty').hide();
		$('#procedure-group-deadlines-filtered-all').hide();
		$('#procedure-group-deadlines-and-other')
			.show()
			.text('+ dalších ' + (checkedProcedureGroupIds.length - 1));
		$('#procedure-group-deadlines-filtered-groups-heading .groups').show();
	};

	let updateUrl = function (checkedProcedureGroupIds, uncheckedProcedureGroupIds) {
		let newUrl = 'deadlines';

		// all checked or no group
		if (uncheckedProcedureGroupIds.length === 0) {
			window.history.pushState({}, null, newUrl);
			return;
		}

		// everything is unchecked
		if (checkedProcedureGroupIds.length === 0 && uncheckedProcedureGroupIds.length > 0) {
			window.history.pushState({}, null, newUrl + '?procedure-group-ids=');
			return;
		}

		let i = 0;
		for (const checkedProcedureGroupId of checkedProcedureGroupIds) {
			newUrl += i === 0 ? '?' : '&';
			newUrl += 'procedure-group-ids=' + checkedProcedureGroupId;
			i++;
		}

		window.history.pushState({}, null, newUrl);
	};

	let updateDeadlines = function (callUpdateUrl) {
		let checkedProcedureGroupIds = getCheckedProcedureGroupIds();
		let uncheckedProcedureGroupIds = getUncheckedProcedureGroupIds();

		updateTable(checkedProcedureGroupIds);
		updateHeader(checkedProcedureGroupIds, uncheckedProcedureGroupIds);

		if (callUpdateUrl) {
			updateUrl(checkedProcedureGroupIds, uncheckedProcedureGroupIds);
		}
	};

	updateDeadlines(false);

	$(window).on('popstate', function () {
		let url = new URL(window.location.href);
		let ids = url.searchParams.getAll('procedure-group-ids');

		if (ids.length === 0) {
			$('#procedure-group-deadlines-popup input').prop('checked', true);
		} else {
			$('#procedure-group-deadlines-popup input').each(function () {
				$(this).prop('checked', ids.includes($(this).val()));
			});
		}

		updateDeadlines(false);
	});
})(jQuery);
